import {Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnInit} from '@angular/core';
import { DropTargetOptions, FileItem, HttpClientUploadService } from '@wkoza/ngx-upload';
import {
    currentSelectedBsk,
    verifySizeDownLoad,
    verifyExtension,
    verifyExistFile,
} from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { AddFileComponent } from '../addfile';
import { TranslateService } from '@ngx-translate/core';
import { setCurrentSelectedBsk } from '@core/_utils/basket.utils';

export type Mode = 'complete' | 'selectable' | 'disabled' | 'move'

@Component({
    selector: 'basket',
    templateUrl: 'basket.component.html',
    styleUrls: ['basket.component.scss'],
    providers: [HttpClientUploadService],
})
export class BasketComponent implements OnInit{

    /**
     * Properties
     */
    @Input()
    public mode: Mode = 'complete';
    @Input()
    public options: any;
    @Input()
    public showGradient: boolean = true;
    @Input()
    public compactMode: boolean = false;
    @Input()
    public allowFullText: boolean = false;
    /**
     * Emitters
     */
    @Output()
    public onSelect: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    public onFilter: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    public onSearch: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    public onAddDoc: EventEmitter<any> = new EventEmitter<any>();


    /**
     * Variables
     */
    // Affiche le formulaire d'upload
    public displayUpload = false;
    // Compte le nombre de document envoyé avec succès
    public uploadCountSuccess = 0;
    // Compte le nombre de document en erreur d'envoie
    public uploadCountError = 0;
    // Compte le nombre de document à envoer
    public sendingCount = 0;
    // Permet de définir si on bloque l'envoie de document
    public cancelAdd = false;

    public baseRoot;
    public storagePath;
    public priority;
    //
    public currentSelectedBsk: currentSelectedBsk;
    public currentBasket: string;
    // Nom de la bannette courante
    public currentBasketName: string;
    // Type de la bannette courante
    public currenBasketType: string;
    public basket: any[];
    // Utilisation du preprocess
    public usePreProcess = false;
    // Nom du preprocess de séparation
    public preProcessName = '';

    public parameterList: any[];
    public ctrlDouble = [];
    public indexInputMode: string;

    @ViewChild('uploadForm') uploadForm;
    dropOptions: DropTargetOptions = {
        color: 'dropZoneColor',
        colorDrag: 'dropZoneColorDrag',
        colorDrop: 'dropZoneColorDrop',
        multiple: true,
    };

    @ViewChild('addFileItem') public addFileItem: AddFileComponent;

    /**
     * Constructeur de bannette
     * @param _messageService
     * @param uploader
     * @param translate
     */
    constructor(protected _messageService: MessagesService, public uploader: HttpClientUploadService, private translate: TranslateService) {
    }
    /**
     * Initialisation du composant
     */
    public ngOnInit() {
        this.options.Information.Gradient = Number(this.options.Information.Gradient);
        if (this.options.Information.docCount >= this.options.Information.Gradient) {
            this.options.Information.Gradient = this.options.Information.docCount;
        }
        let wGradient = 10;
        this.initUpLoader();
        this.baseRoot = '';
        this.storagePath = '';
        this.priority = '5';
        this.currentSelectedBsk = setCurrentSelectedBsk(this.options, null);
        this.currentBasket = this.currentSelectedBsk.bskLabel;
        this.currentBasketName = this.currentSelectedBsk.bskName;
        this.currenBasketType = this.currentSelectedBsk.bskType;
        this.basket = this.currentSelectedBsk.bskName;
        if (this.options.BaseRoot) {
            if (!Array.isArray(this.options.BaseRoot.Name)) {
                this.baseRoot = this.options.BaseRoot.Name;
            }
            if (!Array.isArray(this.options.BaseRoot.Path)) {
                this.storagePath = this.options.BaseRoot.Path;
            }
            if (!Array.isArray(this.options.BaseRoot.Priority)) {
                this.priority = this.options.BaseRoot.Priority;
            }            
        }
        this.usePreProcess = this.currentSelectedBsk.bskUsePreProcess;
        this.preProcessName = this.currentSelectedBsk.bskPreProcessName;
        this.parameterList = this.currentSelectedBsk.bskParameterList;
        this.indexInputMode = this.currentSelectedBsk.bskIndexInputMode;
    }
    public initUpLoader() {
        this.uploader.queue = [];
        this.uploader.removeAllFromQueue();
        this.resetCounter();
        this.cancelAdd = false;
        this.uploader.onCancel$.subscribe((data: FileItem) => {
            console.log('file deleted: ' + data.file.name, data.isSuccess);
        });

        this.uploader.onProgress$.subscribe((data: any) => {
            if (data.progress === 100) {
                this.sendingCount++;
            }
        });

        this.uploader.onSuccess$.subscribe((data: any) => {
            this.uploadCountSuccess++;
            if (
                this.uploadCountSuccess + this.uploadCountError === this.uploader.queue.length &&
                this.cancelAdd === false &&
                this.uploadCountSuccess !== 0
            ) {
                this._messageService.addSuccess(this.translate.instant('File_Send', {nbFile: this.uploadCountSuccess}));
                this.closeAddfile();
            }
        });

        this.uploader.onError$.subscribe((data: any) => {
            console.log('file error: ' + data.item.file.name);
            this.uploadCountError++;
            this._messageService.addErrorMsg(this.translate.instant('Send_On_KO') + data.item.file.name);
        });

        this.uploader.onAddToQueue$.subscribe((data) => {
                this.prepareUpload(data);
        });
    }
    public closeAddfile() {
        this.uploader.queue.map((item, index) => {
            item.remove();
        });
        this.uploader.removeAllFromQueue();
        this.uploader.queue = [];
        this.ctrlDouble = [];
        this.uploadForm.reset();
        this.resetCounter();
        this.cancelAdd = false;
        this.displayUpload = false;
    }
    public cancelAddfile() {
        this.cancelAdd = true;
        let wNbErr = this.uploadCountError;
        let wSend = this.sendingCount;
        this.closeAddfile();
        if (wNbErr === 0) {
            this.displayStopSend(wSend);
        } else {
            if (wSend - wNbErr !== 0) {
                this.displayStopSend(wSend - wNbErr);
            }
        }
    }
    private displayStopSend(aNbFile) {
        this._messageService.addWarn(this.translate.instant('File_Stop', {nbFile: aNbFile}));
    }
    private async prepareUpload(aData) {
        // Ne pas changer l'ordre des 3 lignes
        let wRes = false;
        wRes = verifySizeDownLoad(this.uploader, this._messageService, this.translate);
        if (wRes === false) {
            return;
        }
        wRes = verifyExtension(this.uploader, this._messageService, this.currentSelectedBsk, this.translate);
        if (wRes === false) {
            return;
        }
        this.ctrlDouble = verifyExistFile(this.uploader, aData, this.ctrlDouble);
        if (this.uploader.queue.length !== 0) {
            this.uploadForm.reset();
            this.resetCounter();
            this.displayUpload = true;
            if (this.addFileItem) {
                this.addFileItem.setDocAddList();
            }
        }
    }
    public removeItem(aName) {
        this.ctrlDouble = this.ctrlDouble.filter((item) => {
            return item.name.toLowerCase() !== aName.toLowerCase()
        })
    }
    private resetCounter() {
        this.uploader.progressTotal = 0;
        this.uploadCountSuccess = 0;
        this.uploadCountError = 0;
        this.sendingCount = 0;
    }
    public onSelectBasket(event, aData) {
        event.stopPropagation()
        if (['complete', 'selectable'].includes(this.mode)) {
            this.onSelect.emit({
                selected: event,
                data: aData,
            });
        }
    }
    public trunc(aData) {
        if (aData.length > 30) {
            return aData.substring(0, 30);
        } else {
            return aData;
        }
    }
    public onFilterBasket(event, aData) {
        event.stopPropagation()
        if (['complete', 'selectable'].includes(this.mode)) {
            this.onFilter.emit({
                selected: event,
                id: aData,
            });
        }
    }
    public onFilterBasketSearch(event, aData) {
        event.stopPropagation()
        if (['complete', 'selectable'].includes(this.mode)) {
            this.onSearch.emit({
                selected: event,
                id: aData,
            });
        }
    }
    public onAddDocBasket(event, aData) {
        event.stopPropagation()
        if (['complete', 'selectable'].includes(this.mode)) {
            this.onAddDoc.emit({
                selected: event,
                id: aData,
            });
        }
    }

    public onUpload(event) {
        event.stopPropagation()
    }
    public updateUrl(aData) {
        aData.Information.url = aData.Information.defUrl;
    }
}